// views/js/frontend/product-slider.ts
export class NetBoxProductSlider {
    constructor() {
        this.sliders = new Map();
        this.SLIDER_SELECTOR = '.netbox-swiper';
        if (!this.checkSwiperAvailability()) {
            return;
        }
        this.defaultConfig = this.defaultConfig;
        this.init();
    }
    checkSwiperAvailability() {
        if (typeof window.Swiper === 'undefined') {
            console.error('NetBox ProductSlider: Swiper not loaded!');
            return false;
        }
        return true;
    }
    parseConfig(element) {
        const parentSlider = element.closest('[data-netbox-id]');
        const sliderId = (parentSlider === null || parentSlider === void 0 ? void 0 : parentSlider.dataset.netboxId) || this.generateSliderId();
        let config = { sliderId };
        const slidesPerView = element.dataset.slidesPerView ? parseInt(element.dataset.slidesPerView) : undefined;
        const slidesPerViewMobile = element.dataset.slidesPerViewMobile ? parseInt(element.dataset.slidesPerViewMobile) : undefined;
        const slidesPerViewTablet = element.dataset.slidesPerViewTablet ? parseInt(element.dataset.slidesPerViewTablet) : undefined;
        const slidesPerViewDesktopSm = element.dataset.slidesPerViewDesktopSm ? parseInt(element.dataset.slidesPerViewDesktopSm) : undefined;
        const spaceBetween = element.dataset.spaceBetween ? parseInt(element.dataset.spaceBetween) : undefined;
        if (slidesPerView || slidesPerViewMobile || slidesPerViewTablet || slidesPerViewDesktopSm || spaceBetween) {
            const customBreakpoints = {};
            if (slidesPerViewMobile !== undefined) {
                customBreakpoints[576] = {
                    slidesPerView: slidesPerViewMobile,
                    spaceBetween: spaceBetween || 15
                };
            }
            if (slidesPerViewTablet !== undefined) {
                customBreakpoints[768] = {
                    slidesPerView: slidesPerViewTablet,
                    spaceBetween: spaceBetween || 20
                };
            }
            if (slidesPerViewDesktopSm !== undefined) {
                customBreakpoints[992] = {
                    slidesPerView: slidesPerViewDesktopSm,
                    spaceBetween: spaceBetween || 24
                };
            }
            if (slidesPerView !== undefined) {
                customBreakpoints[1200] = {
                    slidesPerView: slidesPerView,
                    spaceBetween: spaceBetween || 30,
                    centeredSlides: false,
                };
            }
            config.breakpoints = customBreakpoints;
        }
        const configData = element.dataset.swiperConfig;
        try {
            if (configData) {
                const parsed = JSON.parse(configData);
                config = Object.assign(Object.assign({}, config), parsed);
            }
        }
        catch (error) {
            console.warn('NetBox ProductSlider: Invalid config JSON', error);
        }
        return config;
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initializeSliders());
        }
        else {
            this.initializeSliders();
        }
    }
    initializeSliders() {
        const sliderElements = document.querySelectorAll(this.SLIDER_SELECTOR);
        if (sliderElements.length === 0) {
            return;
        }
        sliderElements.forEach(element => {
            const config = this.parseConfig(element);
            this.createSlider(element, config);
        });
    }
    createSlider(element, config) {
        const sliderId = config.sliderId;
        if (this.sliders.has(sliderId)) {
            console.warn(`NetBox ProductSlider: Slider ${sliderId} already exists`);
            return;
        }
        const container = element.closest('[data-netbox-id]');
        const nextButton = container === null || container === void 0 ? void 0 : container.querySelector('.swiper-button-next');
        const prevButton = container === null || container === void 0 ? void 0 : container.querySelector('.swiper-button-prev');
        const swiperConfig = Object.assign(Object.assign(Object.assign(Object.assign({ slidesPerView: 1, spaceBetween: 20, centeredSlides: false, slidesPerGroup: 1, loop: false, freeMode: false, resistance: true, resistanceRatio: 0.85, touchEventsTarget: 'container', threshold: 5 }, this.defaultConfig), (config.breakpoints && { breakpoints: config.breakpoints })), { navigation: nextButton && prevButton ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : false, pagination: false }), (config.autoplay !== undefined && {
            autoplay: config.autoplay ? {
                delay: config.interval || 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false
        }));
        try {
            const swiper = new window.Swiper(element, swiperConfig);
            this.attachManualNavigation(swiper, nextButton, prevButton);
            this.sliders.set(sliderId, swiper);
        }
        catch (error) {
            console.error(`NetBox ProductSlider: Failed to initialize slider ${sliderId}:`, error);
        }
    }
    attachManualNavigation(swiper, nextButton, prevButton) {
        if (nextButton) {
            nextButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                swiper.slideNext();
            });
        }
        if (prevButton) {
            prevButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                swiper.slidePrev();
            });
        }
    }
    generateSliderId() {
        return `slider_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    getSlider(sliderId) {
        return this.sliders.get(sliderId);
    }
    destroySlider(sliderId) {
        const swiper = this.sliders.get(sliderId);
        if (swiper) {
            swiper.destroy(true, true);
            this.sliders.delete(sliderId);
        }
    }
    destroyAll() {
        this.sliders.forEach((swiper, sliderId) => {
            this.destroySlider(sliderId);
        });
    }
    getActiveCount() {
        return this.sliders.size;
    }
}
// Auto-initialize
new NetBoxProductSlider();
